import { useQuery } from '@tanstack/react-query';

import { getAccountingPeriodMetadata } from './accountingPeriod';
import type { AccountingPeriodMetadata } from './accountingPeriod.types';
import { ACCOUNTING_PERIOD_METADATA_KEY } from './constants';

export const useGetAccountingPeriodMetadata = () => {
  return useQuery<AccountingPeriodMetadata>({
    queryKey: [ACCOUNTING_PERIOD_METADATA_KEY],
    queryFn: getAccountingPeriodMetadata,
  });
};
